// ============================================================================
// UOM ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams, buildEndpointWithQuery } from './base.endpoints';

const UOM_BASE = '/common/uoms';

export const uomEndpoints = {
  // Writes — the Units of Measure screen (ADR-0058 slice 1).
  getById: (id: string) => buildEndpointWithParams(`${UOM_BASE}/:id`, { id }),
  create: () => buildEndpoint(UOM_BASE),
  update: (id: string) => buildEndpointWithParams(`${UOM_BASE}/:id`, { id }),
  delete: (id: string) => buildEndpointWithParams(`${UOM_BASE}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${UOM_BASE}/validate/code/:code`, { code }),

  /** GET /api/v1/common/uoms?category=&search= */
  list: (category?: string, search?: string) => {
    // buildEndpoint adds the /v1 version prefix; buildEndpointWithQuery
    // expects a pre-built endpoint (see comment in base.endpoints.ts).
    // Passing the raw '/common/uoms' to buildEndpointWithQuery would skip
    // the version prefix and hit /api/common/uoms (404). Same trap the
    // currency endpoint hit — see fairbooks-web/CLAUDE.md.
    const base = buildEndpoint('/common/uoms');
    const query: Record<string, string> = {};
    if (category) query.category = category;
    if (search) query.search = search;
    return Object.keys(query).length ? buildEndpointWithQuery(base, query) : base;
  },
} as const;
